import React from 'react';
import { motion } from 'framer-motion';
import './Load.scss';


const Load = () => {
    return (
        <div className="load">
            <motion.div 
            style={{background: "#E62625", width: "30px", height: "30px", borderRadius: "100px"}}
            animate={{y: -50}}
            transition={{repeat: Infinity, type:"tween", repeatType: 'mirror'}}
            ></motion.div>
            <motion.div 
            style={{background: "#EC7534", width: "30px", height: "30px", borderRadius: "100px"}}
            animate={{y: -50}}
            transition={{delay: 0.2, type:"tween", repeat: Infinity, repeatType: 'mirror'}}
            ></motion.div>
            <motion.div 
            style={{background: "#4E5DAA", width: "30px", height: "30px", borderRadius: "100px"}}
            animate={{y: -50}}
            transition={{delay: 0.4, type:"tween", repeat: Infinity, repeatType: 'mirror'}}></motion.div>
            <motion.div 
            style={{background: "#65C293", width: "30px", height: "30px", borderRadius: "100px"}}
            animate={{y: -50}}
            transition={{delay: 0.6, type:"tween", repeat: Infinity, repeatType: 'mirror'}}></motion.div>
            <motion.div 
            style={{background: "#F7D138", width: "30px", height: "30px", borderRadius: "100px"}}
            animate={{y: -50}}
            transition={{delay: 0.8, type:"tween", repeat: Infinity, repeatType: 'mirror'}}></motion.div>
        </div>
    )
}

export default Load
